import newStyled from '@emotion/styled'

export const InputLabel = newStyled.span`
  display: inline-block;
  margin: 10px 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #232323;
`
